<button
    (click)="saveDialogClick()"
    hisImage="save"
    class="plamButton icon"
    [title]="'common.save' | hisUi">
    {{ "common.save" | hisUi }}
</button>
@if (report) {
    <p-dialog
        [(visible)]="saveDialog"
        [responsive]="true"
        [modal]="true"
        [dismissableMask]="true"
        [blockScroll]="true"
        [header]="'cs.bia.analysis.saveAnalysis' | hisUi">
        <div class="layoutBlock">
            <div class="columnFullWidth">
                <his-plam
                    [required]="true"
                    [showLabelTop]="false"
                    [label]="'cs.bia.analysis.name' | hisUi">
                    <input
                        #content
                        [(ngModel)]="report.name"
                        class="inputWidth100" />
                </his-plam>
                <his-plam
                    [showLabelTop]="false"
                    [label]="'cs.bia.analysis.description' | hisUi">
                    <textarea
                        #content
                        [(ngModel)]="report.description"
                        class="textareaWidth100">
.</textarea>
                </his-plam>
            </div>
        </div>
        <ng-template #footer>
            <div class="layoutBlock">
                <div class="columnHalf">
                    <button
                        hisImage="TICK"
                        [disabled]="!saveEnabled()"
                        class="button_highlighted"
                        type="button"
                        (click)="report.name && doesReportDefinitionExist(report.name)">
                        {{ "common.saveAndClose" | hisUi }}
                    </button>
                    <button
                        type="button"
                        (click)="saveDialog = false">
                        {{ "common.cancel" | hisUi }}
                    </button>
                </div>
            </div>
        </ng-template>
    </p-dialog>
}
@if (report) {
    <p-dialog
        [(visible)]="reallyWantToSaveDialog"
        [responsive]="true"
        [modal]="true"
        [dismissableMask]="true"
        [blockScroll]="true"
        [header]="'cs.bia.analysis.overwriteAnalysisHeader' | hisUi">
        <p>{{ hisUi.translate("cs.bia.analysis.alreadyExist", report.name ?? "") }}</p>
        <p>{{ hisUi.translate("cs.bia.analysis.alreadyExist.second", report.name ?? "") }}</p>
        <div class="clearAndSpace"></div>
        <button
            id="save"
            type="button"
            (click)="saveReportDefinition()">
            {{ "cs.bia.analysis.overwriteAnalysis" | hisUi }}
        </button>
        <button
            type="button"
            (click)="reallyWantToSaveDialog = false">
            {{ "common.cancel" | hisUi }}
        </button>
    </p-dialog>
}
